// src/api/kingdeeApi.ts
import request from '@/utils/request';

/**
 * 金蝶API模块
 */
export const kingdeeApi = {
    /**
     * 获取销售出库单编号列表
     */
    getBillNoList: (requestData: any) => {
        return request.post('/api/app/sale/outreceipt/billNo/page', requestData)
    },
    /**
     * 根据单据编号获取销售出库单详情
     */
    getSaleOutReceiptDetail: (requestData: any) => {
        return request.get('/api/app/sale/outreceipt/billNo', requestData)
    },
    /**
     * 获取销售出库单列表
     */
    getSaleOutReceiptPageList: (requestData: any) => {
        return request.post('/api/app/sale/outreceipt/page', requestData)
    },
    /**
     * 获取收款单分页数据
     */
    getReceiptList: (requestData: any) => {
        return request.post('/api/kingdee/receipt/page', requestData)
    },
    /**
     * 根据收款单编码获取图片
     */
    getReceiptImage: (requestData: any) => {
        return request.get('/api/kingdee/receipt/image/billNo', requestData)
    },
    /**
     * 创建对账单
     */
    createRecon: (requestData: any) => {
        return request.post('/api/app/create/recon', requestData)
    },
    /**
     * 修改对账单
     */
    confirmRecon: (requestData: any) => {
        return request.post('/api/app/recon/update/status', requestData)
    },
    /**
     * 删除对账单
     */
    deleteReconById: (requestData: any) => {
        return request.get('/api/app/recon/delete/id', requestData)
    },
    /**
     * 获取对账单分页数据
     */
    getReconList: (requestData: any) => {
        return request.post('/api/app/recon/page', requestData)
    },
    /**
     * 根据拼接单据号获取销售出库单列表
     */
    getSaleOutReceiptByBillNos: (requestData: any) => {
        return request.get('/api/app/sale/outreceipt/billNos', requestData)
    },
    /**
     * 获取采购入库单列表
     */
    getPurchaseList: (requestData: any) => {
        return request.post('/api/app/sale/purchase/all/list', requestData)
    },
    /**
     * 获取采购入库单列表
     */
    getSalePurchaseByBillNos: (requestData: any) => {
        return request.get('/api/app/sale/purchase/billNos', requestData)
    },
    /**
     * 获取银行账户分页数据
     */
    getBankAccountPageData: (requestData: any) => {
        return request.post('/api/kingdee/bank-account/page', requestData)
    },
    /**
     * 获取客户分页数据
     */
    getCustomerPageData: (requestData: any) => {
        return request.post('/api/kingdee/customer/page', requestData)
    },
    /**
     * 获取部门分页数据
     */
    getDepartmentPageData: (requestData: any) => {
        return request.post('/api/kingdee/department/page', requestData)
    },
    /**
     * 根据名称获取部门数据
     */
    getDepDataByName: (requestData: any) => {
        return request.get('/api/kingdee/department/name', requestData)
    },
    /**
     * 获取职员分页数据
     */
    getEmpPageData: (requestData: any) => {
        return request.post('/api/kingdee/emp/page', requestData)
    },
    /**
     * 根据名称获取业务员数据
     */
    getEmpDataByName: (requestData: any) => {
        return request.get('/api/kingdee/emp/name', requestData)
    },
    /**
     * 获取物料分页数据
     */
    getMaterialPageData: (requestData: any) => {
        return request.post('/api/kingdee/material/page', requestData)
    },
    /**
     * 获取仓库分页数据
     */
    getStockPageData: (requestData: any) => {
        return request.post('/api/kingdee/stock/page', requestData)
    },
    /**
     * 获取供应商分页数据
     */
    getSupplierPageData: (requestData: any) => {
        return request.post('/api/kingdee/supplier/page', requestData)
    },
    /**
     * 获取计量单位分页数据
     */
    getUnitPageData: (requestData: any) => {
        return request.post('/api/kingdee/unit/page', requestData)
    },
    /**
     * 获取付款单列表
     */
    getSalePaymentList: (requestData: any) => {
        return request.post('/api/app/sale/payment/supplyName', requestData)
    },
    /**
     * 根据收付款单号获取付款单列表
     */
    getPaymentListByRpNo: (requestData: any) => {
        return request.get('/api/app/sale/payment/billno', requestData)
    },
    /**
     * 获取收款单列表
     */
    getSaleReceiptList: (requestData: any) => {
        return request.post('/api/app/sale/receipt/customerName', requestData)
    },
    /**
     * 根据收付款单号获取收款单列表
     */
    getReceiptListByRpNo: (requestData: any) => {
        return request.get('/api/app/sale/receipt/billno', requestData)
    },
    /**
     * 单据对账
     */
    reconByBill: (requestData: any) => {
        return request.post('/api/kingdee/recon/bill', requestData)
    },
    /**
     * 根据单据号批量修改收款状态
     */
    updateProceedStatusByNos: (requestData: any) => {
        return request.post('/api/kingdee/outreceipt/update/numbers', requestData)
    },
    /**
     * 根据条件获取收款记录数据
     */
    getCollectionRecordList: (requestData: any) => {
        return request.post('/api/kingdee/collection-record/get', requestData)
    },
    /**
     * 创建收款单 PC
     */
    createReceiptPC: (requestData : any) => {
        return request.post('/api/app/create/receipt/pc', requestData)
    },
    /**
     * 创建收款记录
     */
    addCollectionRecord: (requestData : any) => {
        return request.post('/api/kingdee/collectionRecord/add', requestData)
    },
    /**
     * 更新销售出库单
     */
    updateSaleOutbound: (requestData : any) => {
        return request.post('/api/kingdee/sale/receipt/update', requestData)
    },
    /**
     * 修改收款记录
     */
    updateCollectionRecord: (requestData : any) => {
        return request.post('/api/kingdee/collectionRecord/update', requestData)
    },
    /**
     * 根据id删除收款记录
     */
    deleteCollectionRecord: (requestData : any) => {
        return request.get('/api/kingdee/collectionRecord/delete', requestData)
    },
    /**
     * 修改收款记录处理状态
     */
    updateCollectionRecordDispose: (requestData : any) => {
        return request.get('/api/kingdee/collectionRecord/update/dispose', requestData)
    },
};
